import React, { useState, useEffect } from "react";
import "../../../assets/css/topbar.css";

const Topbar = () => {
    const swipeData = ['Enjoy hassle-free returns and exchanges', 'Free shipping on every order delivered across India!'];
    const [index, setIndex] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % swipeData.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [swipeData.length]);

    return (
        <div className="topnavbar" style={{ backgroundColor: "#511d00", padding: "10px", color: "#ffffff", textAlign: "center" }}>
            <div
                key={index}
                className="slide-text"
            >
                {swipeData[index]}
            </div>
        </div>
    );
};

export default Topbar;
